import { windowWidth } from './utils';

const headerHoverPopups = {
  btns: Array.from(document.querySelectorAll('.jsPopupBtns')) as HTMLElement[],
  wraps: Array.from(
    document.querySelectorAll('.jsPopupWraps'),
  ) as HTMLElement[],
  overlay: document.getElementById('jsPopupOverlay') as HTMLElement,

  init() {
    if (windowWidth > 1200) {
      this.setHoverState();
      this.removeHoverState();
    }
    this.setClosePopupListener();
  },

  setHoverState() {
    this.btns.forEach((btn) => {
      btn.addEventListener('mouseenter', () => {
        this.handleHover(btn);
      });
    });
  },

  handleHover(activeBtn: HTMLElement) {
    const popupId = activeBtn.getAttribute('data-popup');

    setTimeout(() => {
      this.btns.forEach((btn) => {
        const wrap = this.getWrapForButton(btn);
        const wrapPopupId = wrap.getAttribute('data-popup');

        if (popupId === wrapPopupId) {
          btn.classList.add('activeClass');
          wrap.classList.add('activeClass');
        //   this.overlay.classList.add('activeClass');
        } else {
          btn.classList.remove('activeClass');
          wrap.classList.remove('activeClass');
        }
      });
    }, 150);
  },

  getWrapForButton(btn: HTMLElement): HTMLElement {
    const btnPopupId = btn.getAttribute('data-popup');
    return this.wraps.find(
      (wrap) => wrap.getAttribute('data-popup') === btnPopupId,
    ) as HTMLElement;
  },

  removeHoverState() {
    window.addEventListener('mouseover', this.handleMouseOut.bind(this));
  },

  handleMouseOut(e: MouseEvent) {
    const target = e.target as HTMLElement;

    if (!this.isHoveredElement(target)) {
      setTimeout(() => {
        this.btns.forEach((btn) => {
          const wrap = this.getWrapForButton(btn);
          btn.classList.remove('activeClass');
          wrap.classList.remove('activeClass');
        //   this.overlay.classList.remove('activeClass');
        });
      }, 100);
    }
  },

  isHoveredElement(target: HTMLElement): boolean {
    return [...this.btns, ...this.wraps].some(
      (element) => element === target || element.contains(target),
    );
  },

  setClosePopupListener() {
    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.closePopups();
      });
    }

    const closeButtons = document.querySelectorAll(
      '.close-popup',
    ) as NodeListOf<HTMLElement>;
    closeButtons.forEach((closeBtn) => {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.closePopups();
      });
    });
  },

  closePopups() {
    this.btns.forEach((btn) => {
      btn.classList.remove('activeClass');
    });
    this.wraps.forEach((wrap) => {
      wrap.classList.remove('activeClass');
    });
    // this.overlay.classList.remove('activeClass');
  },
};

export default headerHoverPopups;